/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyResponseModel } from '../../models/client-survey-response-model';

export interface GetSurveyResponse$Json$Params {

/**
 * id of surveyresponse for filter
 */
  surveyResponseId: number;
}

export function getSurveyResponse$Json(http: HttpClient, rootUrl: string, params: GetSurveyResponse$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyResponseModel>> {
  const rb = new RequestBuilder(rootUrl, getSurveyResponse$Json.PATH, 'get');
  if (params) {
    rb.path('surveyResponseId', params.surveyResponseId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyResponseModel>;
    })
  );
}

getSurveyResponse$Json.PATH = '/api/SurveyResponse/{surveyResponseId}';
